import axios from 'axios';
import {
    Dialog
} from 'vant';

import store from '../../store/index.js'
let util = {

};
util.title = function (title) {
    title = title ? title + ' - Home' : '';
    window.document.title = title;
};

/**
 * 接口返回 code 的值
 * 1000 操作成功
 * 1001 参数错误
 * 1002 系统错误
 * 1003 登录超时
 * 1004 数据为空
 * 2001 验证码错误
 * 304 未修改
 * 307 临时重定向
 * 400 参数异常
 * 401 未登录
 * 403 没有权限
 * 418 信息违法
 * 500 内部服务器错误
 * 501 未实现
 */

// const proURL  = window.location.protocol + "//izt.eastfair.cn/visitor/v2";
const proURL  = "https://izt.eastfair.cn"; // /visitor/v2
// 海报接口本地测试
// const testURL = "/visitor/v2";
const testURL = window.location.protocol + "//10.20.16.98:9002/visitor/v2";

util.ajax = axios.create({
    // baseURL: proURL,
    baseURL: ['production', 'prod'].includes(process.env.NODE_ENV) ? proURL : testURL,
    timeout: 30000
});


export function axiosfetch(options) {

    return new Promise((resolve, reject) => {

        var params = options.params;
        var baseUrl = options.baseUrl;
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
        }
        // unNeedAuth: true === 不需要header Authorization
        if (options.unNeedAuth) {
            headers.Authorization = ''
        } else {
            headers.Authorization = decodeURIComponent(store.state.user.token).replace(/\s/g, '+')
        }

        const instance = axios.create({
            // baseURL: proURL,
            // baseURL: testURL,
            baseURL: baseUrl ? baseUrl : (['production', 'prod'].includes(process.env.NODE_ENV) ? proURL : testURL),
            timeout: 30000,
            //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
            //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
            headers: {
                // "Authorization": decodeURIComponent(store.state.user.token), // decodeURIComponent(store.state.user.token)
                // "Authorization": 'GW1yXNm1dXScd12i7KwdZ+Ycb8SzGAYgS88lqR00dETrg+m9AGtiGHg/fhAWPulRIuSE+PkZG3TAmN4TBhX/k9e8SmnbGg2l/u1iwIDNhUdnELg7oSOimeJuWhBc8FyztuzxWL8QkbH5IYziLCLbuv9vXE4AygmMh5vOMqQ1qQK+hM/rDnGqB5R2pHgeKLkTrc42+z6uAcmQDZvpcEQ4Lm/ejLm8w8ombPEFsOc8Qd9YCs78lWlJov0QcOXrsr8GN1HhYXA1FPI5rTaMenH7/ZrRbVqP9VSpnveBr2NqoqfFLBuAevzwhw6eMl1mscsTkST6+9h4qoxx9f4Xm5nvYM3xbswopKB+W4FGbFpsWfyN9ikdNdKkte7vj7xa9bRctwX8T68y7qQLhPuT08nbCc+d1qAf9g0EWuvjcHhqva6tAaFQpitZnQgiX6rco48MlBvldAYeoq+YoUz4//UBt7tH+S5/fsxCPwz05x8yseI=',
                // 'Content-Type': 'application/json;charset=UTF-8',
                // "X-CID":cid,
                // "X-LOCALE":language,
                // "X-SIGN":sign_str
                ...headers
            },
            // timeout: 30 * 1000 //30秒超时
        });

        let httpDefaultOpts = { //http默认配置
            method: options.method,
            url: options.url,
            timeout: 600000,
            params: Object.assign(params),
            data: Object.assign(params),
        }

        if (options.method == 'get') {
            delete httpDefaultOpts.data
        } else {
            delete httpDefaultOpts.params
        }
        instance(httpDefaultOpts)
            .then(response => { //then 请求成功之后进行什么操作
                if (response.data.code == 401) {
                    Dialog({
                        message: response.data.message
                    });
                    return
                }
                if (response.data.code == 1000 || response.data.code == '0000' || response.data.errorCode === 0) {
                    resolve(response.data) //把请求到的数据发到引用请求的地方
                    return
                }
                reject(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}

/**上传图片的方法*/
export function getUploadImage(url, options) {
    return new Promise((resolve, reject) => {
        var token = window.localStorage.getItem('token') ? window.localStorage.getItem('token') : "";
        const instance = axios.create({
            //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
            //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token
            },
            timeout: 30 * 1000 //30秒超时
        });
        instance.post(url, options)
            .then(response => {
                if (response.data.errno == 403) {
                    alert(response.data.errmsg)
                    return
                }
                resolve(response)
            })
            .catch(error => {
                console.log('上传图片异常=>' + error);
                reject(error)
            })
    })
}